<template>
  <v-container
    id="app-loyalty-questions"
    class="pa-1"
  >
    <screen
      use-amount
      :title="solde ? $t('words.solde') : null"
      :info="solde ? $amount(solde) : null"
    />

    <div class="text-center pa-3">
      <div
        v-if="carrier"
        class="py-3"
      >
        <h2>{{ carrier.Nom }}</h2>
        <h3 class="mt-2">
          {{ carrier.Prenom }}
        </h3>
      </div>
      <p
        v-else
        class="error pa-3"
      >
        Aucun contact
      </p>

      <v-btn
        color="success"
        class="mt-5"
        height="100"
        x-large
        block
        @click="valid"
      >
        Valider la transaction
      </v-btn>
    </div>

    <div class="pull-bottom bloc pa-3">
      <v-btn
        color="error"
        x-large
        block
        @click="cancel"
      >
        Annuler
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { Scan } from '@/modules/Scan'
import { $alert, $amount, createReference } from '@/modules/Utils'

export default {
  name: 'LoyaltyCheckCarrier',

  props: {
    idBadge: { type: String, default: null },
    carrier: { type: Object, default: null },
    clientQuestions: { type: Object, default: null },
    loyaltyQuestions: { type: Object, default: null },
    solde: { type: Number, default: 0 },
    postJackpotAmount: { type: Number, default: null }
  },

  beforeMount () {
    if (!this.idBadge) {
      this.$router.replace('/')
    }
  },

  methods: {
    $amount,
    valid () {
      if (this.$store.getters.postJackpot) {
        // Go to postJackpot
        this.$router.replace({
          name: 'loyalty-jackpot',
          params: { idBadge: this.idBadge, solde: this.solde, clientQuestions: this.clientQuestions, loyaltyQuestions: this.loyaltyQuestions }
        })
      } else if (this.clientQuestions !== null || this.loyaltyQuestions !== null) {
        // Go to questions
        this.$router.replace({
          name: 'loyalty-questions',
          params: { idBadge: this.idBadge, clientQuestions: this.clientQuestions, loyaltyQuestions: this.loyaltyQuestions }
        })
      } else {
        // Start calcul
        Scan.launchFidCalcul(
          this.idBadge,
          (error) => {
            // En cas d'erreur on retourne à la première question
            $alert(error)
          },
          null,
          null,
          null,
          null,
          this.solde,
          createReference()
        )
      }
    },
    cancel () {
      this.$router.replace('/home')
    }
  }
}
</script>
